// eslint-disable-next-line @typescript-eslint/consistent-type-imports
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "StickyElement", {
    enumerable: true,
    get: function() {
        return StickyElement;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _useStickyElement = require("./useStickyElement");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const StickyElement = (param)=>{
    let { children, stack = false } = param;
    const args = (0, _useStickyElement.useStickyElement)({
        stack
    });
    var _children;
    return (_children = children === null || children === void 0 ? void 0 : children(args)) !== null && _children !== void 0 ? _children : null;
};

//# sourceMappingURL=StickyElement.js.map